module.exports = __webpack_public_path__ + "static/media/Mary.320a0782.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/OnboardingHiImMary/assets/Mary.jpg
// module id = 1254
// module chunks = 0